export class ChangePassword {
    userName: string;
    password: string;
    newPassword: string;
    verificationCode: string;
}